$(document).ready(function(){

    var $dropdown = $('.dropdown'),
        $faux_dropdown = $('.faux-dropdown')

    $dropdown.on('show.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown()
        $faux_dropdown.addClass('active')
    })

    $dropdown.on('hide.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp()
        $faux_dropdown.removeClass('active')
    })

})